import React from 'react';
import { Check } from 'lucide-react';
import { DUMPSTERS, formatCurrency, type DumpsterSize } from '../../data/dumpsters';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { cn } from '../../lib/utils';
interface SizesSectionProps {
  onReserve: (sizeId: string) => void;
}
export function SizesSection({
  onReserve
}: SizesSectionProps) {
  return <section id="sizes" className="w-full border-t border-border bg-secondary/40 py-16 md:py-24" data-id="element-255">
      <div className="container" data-id="element-256">
        <div className="mx-auto max-w-2xl text-center" data-id="element-257">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-258">
            Sizes & pricing
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-259">
            One flat price per size — includes a {DUMPSTERS[0].rentalDays}-day
            rental, delivery, pickup, and disposal up to the weight limit. No
            hidden fees.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-260">
          {DUMPSTERS.map(d => <SizeCard key={d.id} dumpster={d} onReserve={() => onReserve(d.id)} data-id="element-261" />)}
        </div>

        <p className="mt-8 text-center text-sm text-muted-foreground" data-id="element-262">
          Overages billed at $65 per additional ton. Prohibited items (paint,
          tires, hazardous waste) not accepted.
        </p>
      </div>
    </section>;
}
function SizeCard({
  dumpster,
  onReserve
}: {
  dumpster: DumpsterSize;
  onReserve: () => void;
}) {
  return <div className={cn('relative flex flex-col rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md', dumpster.popular ? 'border-primary ring-1 ring-primary' : 'border-border')} data-id="element-263">
      {dumpster.popular && <Badge className="absolute -top-3 left-6" data-id="element-264">Most popular</Badge>}
      <p className="text-sm font-medium text-muted-foreground" data-id="element-265">
        {dumpster.yards} cubic yards
      </p>
      <h3 className="mt-1 text-xl font-semibold text-card-foreground" data-id="element-266">
        {dumpster.name}
      </h3>
      <div className="mt-4 flex items-baseline gap-1" data-id="element-267">
        <span className="text-3xl font-semibold text-card-foreground" data-id="element-268">
          {formatCurrency(dumpster.price)}
        </span>
        <span className="text-sm text-muted-foreground" data-id="element-269">flat</span>
      </div>
      <p className="mt-3 text-sm font-medium text-foreground" data-id="element-270">
        {dumpster.bestFor}
      </p>

      <ul className="mt-4 space-y-2 text-sm text-muted-foreground" data-id="element-271">
        <li className="flex items-center gap-2" data-id="element-272">
          <Check className="h-4 w-4 shrink-0 text-primary" data-id="element-273" />
          {dumpster.rentalDays}-day rental included
        </li>
        <li className="flex items-center gap-2" data-id="element-274">
          <Check className="h-4 w-4 shrink-0 text-primary" data-id="element-275" />
          Up to {dumpster.weightLimit}
        </li>
        <li className="flex items-center gap-2" data-id="element-276">
          <Check className="h-4 w-4 shrink-0 text-primary" data-id="element-277" />
          {dumpster.dimensions}
        </li>
      </ul>

      <Button className="mt-6 w-full" variant={dumpster.popular ? 'default' : 'outline'} onClick={onReserve} data-id="element-278">
        Reserve this size
      </Button>
    </div>;
}